/* eslint-disable no-console */
import { Component, Prop, Ref, SimpleEvent } from "@eastsideco/salvo-ts";
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class BrochureForm extends ThemeComponent {

    @Ref brochureForm!: HTMLElement;

    init() {
        this.getButtonElements();

    }


    listenToClick(buttons: HTMLButtonElement[]) {
        for (const button of buttons) {

            this.$listen(button, 'click', (event) => {
                const formRect = this.brochureForm.getBoundingClientRect();
                const addExtra = formRect.x + 200;
                window.scrollTo(addExtra, 0);
                this.getButtonElements();
            });
        }
    }

    getButtonElements() {
        let buttons;

        setTimeout(() => {
            buttons = this.brochureForm.querySelectorAll('button') as unknown as HTMLButtonElement[];
            this.listenToClick(buttons);
        }, 2000);
    }
}
